import React, { Component } from 'react'
import MusicPlayer from '../../components/MusicPlayer'
import H1 from '../../components/H1'
import '../../styles/css/music.css'

const section = {
    target: 'music',
    title: 'Music Production'
}

class Music extends Component {
    constructor(props){
        super(props)
        this.state = {
            playing: null,
            metadata: null
        }
    }
    
    play = index => {
        this.setState({
            playing: this.state.playing === index ? null : index
        })
    }

    onEnded = () => {
        this.setState({
            playing: this.state.playing < this.props.tracks.length - 1 ? this.state.playing + 1 : 0
        })
    }

    toggleMetadata = index => {
        this.setState({
            metadata: this.state.metadata === index ? null : index
        })
    }

    render() {
        const { tracks = [] } = this.props
        return (
            <div className="music">
                <div className="music-content">
                    <div className="tracks">
                        <div className="tracks-col">
                            <H1 section={section} />
                            <p>A selection of our most recent tracks just for you.</p>
                        </div>
                        <div className="tracks-col">
                            {tracks.map((track,index) => 
                                <Track
                                    key={index} 
                                    track={track}
                                    index={index}
                                    onClick={this.play}
                                    playing={this.state.playing}
                                    onEnded={this.onEnded}
                                    metadata={this.state.metadata}
                                    toggleMetadata={this.toggleMetadata}
                                    />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const Track = ({ track,index, onClick, playing, onEnded, metadata, toggleMetadata }) => (
    <div className="track-container">
        <div className={playing === index ? 'track playing' : 'track not-playing'}>
            <span onClick={() => onClick(index)}>{index + 1}</span>
            <span onClick={() => onClick(index)}>{track.title}</span>
            <button onClick={() => toggleMetadata(index)} className="toggle-metadata">i</button>
            <span onClick={() => onClick(index)}>{track.length}</span>
        </div>
        {playing === index && <MusicPlayer 
                                file={`https://uploads.newgroundworld.com/tracks/${track.file}`}
                                onEnded={onEnded} />}
        {metadata === index && <Metadata track={track} /> }
    </div>
)

const Metadata = ({ track }) => {
    return(
        <div className="track-metadata">
        <div className="metadata">
            <h4>Artist(s)</h4>
            <p>{track.artist}</p>
        </div>
        <div className="metadata">
            <h4>Producer(s)</h4>
            <p>{track.producer}</p>
        </div>
        <div className="metadata">
            <h4>Writer(s)</h4>
            <p>{track.writer}</p>
        </div>
        <div className="metadata">
            <h4>Mixed and Mastered</h4>
            <p>{track.mixed_mastered}</p>
        </div>
        <div className="metadata lyrics">
            <h4>Lyrics</h4>
            <p>{track.lyrics}</p>
        </div>
    </div>
    )
}

export default Music


// WEBPACK FOOTER //
// ./src/containers/home/music.js